import React, { useState } from "react";
import { Layout, Tabs } from "antd";
import logo from "../../config/img/logo.png";
import LoginForm from "./component/login_form";
import { BRAND_NAME, WEB_DOMAIN } from "../../config/config";
import RegisterForm from "./component/register_form";
import "./style.css";
const { Content } = Layout;

const items = [
  { label: "Đăng nhập", key: "login" },
  { label: "Đăng Ký", key: "register" },
];

const Login = () => {
  // -------------------------- STATE --------------------------
  const [tab, setTab] = useState("login");
  // -------------------------- FUNCTION --------------------------
  // -------------------------- RENDER --------------------------

  const LogoSection = () => {
    return (
      <div
        style={{
          paddingTop: 10,
          display: "flex",
          alignItems: "center",
          marginBottom: -10,
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <img src={logo} className="login-logo" alt="branch-logo" />
          <span style={{ margin: "0px 0px 10px", color: "#aeaeae" }}>
            Nhà Vận Hành
          </span>
        </div>
      </div>
    );
  };

  const TabSection = () => {
    return (
      <Tabs activeKey={tab} onChange={(value) => setTab(value)} items={items} />
    );
  };

  const Copyright = () => {
    return (
      <p variant="body2" color="textSecondary" align="center">
        {"Copyright © "}
        <a color="inherit" href={WEB_DOMAIN} alt="Copyright">
          {BRAND_NAME}
        </a>{" "}
        {new Date().getFullYear()}
        {"."}
      </p>
    );
  };

  const renderLogin = () => {
    if (tab === "register") return null;
    return <LoginForm />;
  };

  const renderRegister = () => {
    if (tab === "login") return null;
    return <RegisterForm />;
  };

  // -------------------------- MAIN --------------------------
  return (
    <Layout className="full">
      <Content className="login">
        <div className="center">
          <LogoSection />
          <TabSection />
          {renderLogin()}
          {renderRegister()}
        </div>
      </Content>
      <Copyright />
    </Layout>
  );
};

export default Login;
